import React from 'react';
import PropTypes from 'prop-types';
import Switch from 'react-switch';
import AsyncSelect from 'react-select/async';
import { Col, Row } from 'reactstrap';
import NumberFormat from 'react-number-format';

const LineForm = props =>  {

  const {
    adenda,
    afianzado,
    aumento,
    avales,
    contrafianza,
    enabled,
    fileTable,
    handleChange,
    handleContrafianza,
    handleCambioLimiteContrafianza,
    handleLine,
    handleSwitch,
    handleTextArea,
    isFirst,
    justificacion,
    limite,
    limiteContrafianza,
    cambioLimiteContrafianza,
    lineValue,
    loadOptions,
    nuevoMonto,
    isGrupo,
  } = props;

  const hasLimit = limiteContrafianza !== -1;
  const adendaDisplay =  limite > 0 ? nuevoMonto > limite : false;
  return (
    <div>
      <Row>
        <Col className="form-block">
          <div className="label">
            Afianzado
          </div>
          {!isGrupo && (
            <p className="form-values" id="afianzado">
              {`${afianzado.rut} - ${afianzado.nombre}`}
            </p>
          ) || (
            <p className="form-values" id="afianzado">
              {`${afianzado.nombre}`}
            </p>
          )}
          {isFirst && !isGrupo && (
            <p className="first-warning">
              * Este es el primer movimiento de línea, por lo que la contrafianza es obligatoria
            </p>
          )}
        </Col>
      </Row>
      <Row>
        {isFirst && !isGrupo && (
          <Col className="form-block" sm={{ size: 7 }}>
            <div className="d-flex">
              <div className="label">
                Avales
              </div>
              <div className='switch'>
                {/* eslint-disable */}
                <label>
                  <Switch
                    checked={enabled}
                    checkedIcon=""
                    height={20}
                    width={40}
                    onChange={handleSwitch}
                    onColor="#39CA74"
                    offColor="#CCCCCC"
                    uncheckedIcon=""
                  />
                </label>
                {/* eslint-enable */}
              </div>
            </div>
            <div className="value">
              <AsyncSelect
                cacheOptions
                defaultOptions
                id="afianzado"
                isDisabled={!enabled}
                isClearable
                isMulti
                loadOptions={loadOptions}
                name="afianzado"
                onChange={handleChange}
                value={enabled ? avales : []}
                placeholder="Seleccionar avales"
              />
            </div>
          </Col>
        )}
        <Col className="form-block" sm={{ size: 4, offset: isFirst ? 1 : 0}}>
          <div className="label">
            Monto UF
          </div>
          <div className="value">
            <NumberFormat
              allowNegative={false}
              className="form-control"
              decimalScale="2"
              fixedDecimalScale
              decimalSeparator=","
              id="deltaLinea"
              name="deltaLinea"
              onValueChange={values => handleLine(values)}
              prefix={!aumento ? '-' : ''}
              thousandSeparator="."
              value={lineValue}
            />
          </div>
        </Col>
        {(!isFirst || isGrupo) && (
          <>
            <Col className="form-block" sm={{ size: 3, offset: 1 }}>
              <div className="label">
                Nuevo Monto
              </div>
              <div className="value">
                <p className="form-values" id="nuevoMonto">
                  <NumberFormat
                    decimalScale="2"
                    fixedDecimalScale
                    decimalSeparator=","
                    displayType="text"
                    value={nuevoMonto}
                    thousandSeparator="."
                  />
                </p>
              </div>
            </Col>
            <Col className="form-block" sm={{ size: 3, offset: 1 }}>
              <div className="label">
                Monto Límite
              </div>
              <div className="value">
                <p className="form-values" id="montoLimite">
                  <NumberFormat
                    decimalScale="2"
                    fixedDecimalScale
                    decimalSeparator=","
                    displayType="text"
                    value={limite >= 0 ? limite : '-'}
                    thousandSeparator="."
                  />
                </p>
              </div>
            </Col>
          </>
        )}
      </Row>
      {(!isFirst || isGrupo) && !adendaDisplay && (
        <Row>
          <Col>
            <div className="label">
              Justificación
            </div>
            <div className="textarea">
              <textarea
                className="form-control"
                id="justificacion"
                name="justificacion"
                onChange={handleTextArea}
                placeholder="Escribir justificación"
                rows="2"
                value={justificacion}
              />
            </div>
          </Col>
        </Row>
      )}
      {!isFirst && adendaDisplay && (
        <>
          <Row>
            <Col>
              <div className="adenda-warning">
                El monto ingresado supera el límite establecido anteriormente. Por esto, debe adjuntar
                la adenda correspondiente e ingresar un nuevo límite.
              </div>
              {adenda}
            </Col>
          </Row>
          <Row>
            <Col className="form-block" sm={{ size: 4 }}>
              <div className="label">
                Aumento límite UF
              </div>
              <div className="value">
                <NumberFormat
                  allowNegative={false}
                  className="form-control"
                  decimalScale="2"
                  fixedDecimalScale
                  decimalSeparator=","
                  id="deltaLinea"
                  name="deltaLinea"
                  onValueChange={handleCambioLimiteContrafianza}
                  thousandSeparator="."
                  value={cambioLimiteContrafianza}
                />
              </div>
            </Col>
          </Row>
        </>
      )}
      {isFirst && !isGrupo && (
        <>
          <Row>
            <Col>
              <div className="label">Adjuntar Contrafianza</div>
              {contrafianza}
            </Col>
          </Row>
          <Row>
            <Col className="form-block" sm={{ size: 5 }}>
              <div className="d-flex">
                <div className="label">
                  Límite Contrafianza UF
                </div>
                <div className='switch'>
                  {/* eslint-disable */}
                  <label>
                    <Switch
                      checked={hasLimit}
                      checkedIcon=""
                      height={20}
                      width={40}
                      onChange={() => handleContrafianza(hasLimit)}
                      onColor="#39CA74"
                      offColor="#CCCCCC"
                      uncheckedIcon=""
                    />
                  </label>
                  {/* eslint-enable */}
                </div>
              </div>
              <div className="value" style={{ width: '50%' }}>
                <NumberFormat
                  allowNegative={false}
                  className="form-control"
                  decimalScale="2"
                  fixedDecimalScale
                  decimalSeparator=","
                  id="deltaLinea"
                  disabled={!hasLimit}
                  name="deltaLinea"
                  onValueChange={handleContrafianza}
                  thousandSeparator="."
                  value={hasLimit ? limiteContrafianza : ''}
                />
              </div>
            </Col>
          </Row>
        </>
      )}
      <Row>
        <Col>
          <div className="label">Adjuntar Archivos</div>
          {fileTable}
        </Col>
      </Row>
    </div>
  );
};

LineForm.propTypes = {
  adenda: PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  }).isRequired,
  afianzado: PropTypes.shape({
    rut: PropTypes.string,
    nombre: PropTypes.string,
  }).isRequired,
  aumento: PropTypes.bool.isRequired,
  avales: PropTypes.arrayOf(PropTypes.object).isRequired,
  contrafianza: PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  }).isRequired,
  enabled: PropTypes.bool.isRequired,
  fileTable: PropTypes.node.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleContrafianza: PropTypes.func.isRequired,
  handleCambioLimiteContrafianza: PropTypes.func.isRequired,
  handleLine: PropTypes.func.isRequired,
  handleSwitch: PropTypes.func.isRequired,
  handleTextArea: PropTypes.func.isRequired,
  isFirst: PropTypes.bool,
  justificacion: PropTypes.string.isRequired,
  limite: PropTypes.number.isRequired,
  limiteContrafianza: PropTypes.number.isRequired,
  cambioLimiteContrafianza: PropTypes.number.isRequired,
  lineValue: PropTypes.number.isRequired,
  loadOptions: PropTypes.func.isRequired,
  nuevoMonto: PropTypes.number.isRequired,
  isGrupo: PropTypes.bool,
};

LineForm.defaultProps = {
  isFirst: false,
  isGrupo: false,
};

export default LineForm
